import { newsletterListsApi } from "@circle-react/api/newsletterListsApi";
import type {
  Newsletter,
  NewsletterSlugConflict,
} from "@circle-react/api/newslettersApi";
import { newslettersApi } from "@circle-react/api/newslettersApi";
import { isPositiveInt } from "@circle-react/helpers/number";
import { queryClient } from "@circle-react/providers/QueryClient/reactQueryConfig";
import { queryOptions } from "react-query";

import { newsletterAudienceListKey, newslettersKey } from "./newsletter";

export const newsletterQueries = {
  activationCheck: () =>
    queryOptions({
      queryKey: newslettersKey.key("activation-check"),
      queryFn: () => newslettersApi.activationCheck(),
      refetchOnWindowFocus: true,
    }),
  audienceLists: (newsletterId: number | undefined) =>
    queryOptions({
      queryKey: newsletterAudienceListKey.key(newsletterId ?? 0),
      queryFn: () => {
        if (!newsletterId) throw new Error("Newsletter ID is required.");

        return newsletterListsApi.list({ newsletterId });
      },
      enabled: isPositiveInt(newsletterId),
    }),
  list: () =>
    queryOptions({
      queryKey: newslettersKey.key("list"),
      queryFn: () => newslettersApi.list(),
    }),
};

export const newsletterInvalidations = {
  list: () =>
    queryClient.invalidateQueries({
      queryKey: newslettersKey.key("list"),
    }),
  audienceLists: (newsletterId: number) =>
    queryClient.invalidateQueries({
      queryKey: newsletterAudienceListKey.key(newsletterId),
    }),
};

export const newsletterCache = {
  cancelListFetch: () =>
    queryClient.cancelQueries({ queryKey: newslettersKey.key("list") }),
  setSlugConflict: (slugConflict: NewsletterSlugConflict | null) =>
    queryClient.setQueryData(newslettersKey.key("activation-check"), {
      slug_conflict: slugConflict,
    }),
  add: (newsletter: Newsletter) =>
    queryClient.setQueryData<Newsletter[]>(newslettersKey.key("list"), list => [
      ...(list ?? []).filter(item => item.id !== newsletter.id),
      newsletter,
    ]),
  replace: (newsletter: Newsletter) =>
    queryClient.setQueryData<Newsletter[]>(newslettersKey.key("list"), list =>
      list?.map(item => (item.id === newsletter.id ? newsletter : item)),
    ),
};
